var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 2507,
    viewBox: "0 0 1440 2507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0571429,
    d: "M-17.6568 1994.5C-7.84172 1736.77 144.45 1170.7 675.096 968.218C1338.4 715.112 1337.61 606.829 1400.05 350.012",
    stroke: "#6A6D9E",
    strokeWidth: 1.36706
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.114286,
    d: "M-17.8811 1987.82C13.9699 1732.61 214.074 1183.6 759.681 1029.29C1441.69 836.402 1450.18 728.739 1534.34 479.075",
    stroke: "#6A6D9E",
    strokeWidth: 1.36706
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.171429,
    d: "M-18.7002 1980.8C34.827 1729.97 280.935 1202.04 837.151 1096.96C1532.42 965.616 1550.08 859.364 1655.19 618.68",
    stroke: "#6A6D9E",
    strokeWidth: 1.36706
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.228571,
    d: "M-20.0829 1973.39C54.6021 1728.77 344.572 1225.75 906.971 1170.57C1609.97 1101.6 1636.61 997.532 1761.76 767.574",
    stroke: "#6A6D9E",
    strokeWidth: 1.36706
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.285714,
    d: "M-21.9935 1965.53C73.177 1728.9 404.549 1254.4 968.675 1249.39C1673.83 1243.13 1709.22 1142.01 1853.33 924.437",
    stroke: "#6A6D9E",
    strokeWidth: 1.36706
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.342857,
    d: "M-24.3897 1957.19C90.4462 1730.26 460.466 1287.66 1021.86 1332.69C1723.6 1388.98 1767.42 1291.54 1929.3 1087.89",
    stroke: "#6A6D9E",
    strokeWidth: 1.36706
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M-27.228 1948.32C106.312 1732.7 511.952 1325.12 1066.19 1419.68C1758.99 1537.87 1810.87 1444.8 1989.19 1256.53",
    stroke: "#6A6D9E",
    strokeWidth: 1.36706
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.457143,
    d: "M-30.4619 1938.88C120.688 1736.12 558.673 1366.38 1101.41 1509.55C1779.82 1688.51 1839.34 1600.48 2032.65 1428.89",
    stroke: "#6A6D9E",
    strokeWidth: 1.36706
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.514286,
    d: "M-34.0388 1928.85C133.504 1740.36 600.334 1411.01 1127.32 1601.5C1786.04 1839.61 1852.72 1757.23 2059.48 1603.5",
    stroke: "#6A6D9E",
    strokeWidth: 1.36706
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.571429,
    d: "M-37.9065 1918.2C144.696 1745.3 636.68 1458.53 1143.8 1694.68C1777.7 1989.87 1851 1913.72 2069.58 1778.88",
    stroke: "#6A6D9E",
    strokeWidth: 1.36706
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.628571,
    d: "M-42.0094 1906.9C154.216 1750.77 667.498 1508.46 1150.82 1788.26C1754.97 2138 1834.32 2068.62 2063 1953.56",
    stroke: "#6A6D9E",
    strokeWidth: 1.36706
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.685714,
    d: "M-46.2914 1894.94C162.029 1756.64 692.617 1560.31 1148.4 1881.4C1718.13 2282.76 1802.91 2220.61 2039.91 2126.07",
    stroke: "#6A6D9E",
    strokeWidth: 1.36706
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.742857,
    d: "M-50.6919 1882.3C168.115 1762.75 711.913 1613.58 1136.65 1973.28C1667.56 2422.91 1757.12 2368.42 2000.61 2294.97",
    stroke: "#6A6D9E",
    strokeWidth: 1.36706
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M-55.1523 1868.97C172.464 1768.95 725.304 1667.74 1115.74 2063.09C1603.78 2557.29 1697.42 2510.81 1945.55 2458.86",
    stroke: "#6A6D9E",
    strokeWidth: 1.36706
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.cfb8e2d3e0c77facdf62868eeb7ba8e9.svg";
export { ForwardRef as ReactComponent };